import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import agendaIcon from "../../assets/icons/agenda.png";

import AgendamentosService from "../../services/AgendamentosService";
import CadastrosInternosService from "../../services/CadastrosInternosService";
import EspecialidadesService from "../../services/EspecialidadesService";
import HorariosService from "../../services/HorariosService";

import criarAgendamentoPublicDTO from "../../types/AgendamentoPublicDTO";
import atualizarAgendamentoPublicDTO from "../../types/AgendamentoUpdatePublicDTO";

export default function AgendamentoForm({ itemSelecionado, modo, onClose }) {

  const { setRetorno } = useGerenciamento();
  const [form, setForm] = useState({
    idAgendamento: null,
    idCadastro: "",
    data: "",
    idEspecialidade: "",
    tempo: "",
    idHorario: "", 
  });

  const [clientes, setClientes] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [especialidadeSelecionada, setEspecialidadeSelecionada] = useState(null);
  const [horarios, setHorarios] = useState([]);
  const [blocosHorarios, setBlocosHorarios] = useState([]);
  const hoje = new Date().toISOString().split("T")[0];

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function carregarBase() {
      const [cli, esp] = await Promise.all([
        CadastrosInternosService.getAll(),
        EspecialidadesService.getLista()
      ]);
      setClientes(Array.isArray(cli) ? cli : []);
      setEspecialidades(Array.isArray(esp) ? esp : []);
    }
    carregarBase();
  }, []);

  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idAgendamento: null,
        idCadastro: "",
        data: "",
        idEspecialidade: "",
        tempo: "",
        idHorario: ""
      });
      setHorarios([]);
      setBlocosHorarios([]);
      return;
    }

    if (modo === "alterar" && itemSelecionado) {

      setForm({
        idAgendamento: itemSelecionado.IDAGENDAMENTO,
        idCadastro: String(itemSelecionado.IDCADASTRO),
        data: itemSelecionado.DATA,
        idEspecialidade: String(itemSelecionado.IDESPECIALIDADE),
        tempo: "",
        idHorario: String(itemSelecionado.IDHORARIO),
      });

      carregarHorarios(itemSelecionado.DATA);
    }
  }, [modo, itemSelecionado]);

  async function carregarHorarios(data) {
    if (!data) {
      setHorarios([]);
      setBlocosHorarios([]);
      return;
    }

    try {
      const response = await HorariosService.getDisponiveis(data);
      setHorarios(response || []);
      setBlocosHorarios([]);

      if (Array.isArray(response)) {
        setHorarios(response);
      } else if (Array.isArray(response?.data)) {
        setHorarios(response.data);
      } else {
        setHorarios([]);
      }
      setBlocosHorarios([]);

    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      setHorarios([]);
      setBlocosHorarios([]);
    }
  }

  
  function montarHorariosEmBlocos(horarios, tempoServicoEmMinutos) {
    if (!horarios || horarios.length === 0) return [];

    const blocos = [];
    const blocosNecessarios = Math.ceil(tempoServicoEmMinutos / 60);

    for (let i = 0; i < horarios.length; i++) {
      let valido = true;
      const bloco = [horarios[i]];

      for (let j = 1; j < blocosNecessarios; j++) {
        const atual = horarios[i + j];
        const anterior = horarios[i + j - 1];

        if (!atual) { valido = false; break; }

        const [h1, m1] = anterior.horario.slice(0, 5).split(":").map(Number);
        const [h2, m2] = atual.horario.slice(0, 5).split(":").map(Number);

        if ((h2 * 60 + m2) - (h1 * 60 + m1) !== 60) {
          valido = false;
          break;
        }

        bloco.push(atual);
      }

      if (valido) blocos.push(bloco);
    }

    return blocos;
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setForm(prev => ({ ...prev, [name]: value }));

    if (name === "data") {
      carregarHorarios(value);
      setForm(prev => ({ ...prev, idHorario: "" }));
    }

    if (name === "idEspecialidade") {
      const esp = especialidades.find(es => es.IDESPECIALIDADE === Number(value));
      const tempo = esp?.tempo || esp?.tempo || "";
    
      //console.log("especialidade encontrada:", esp);
      //console.log("tempo capturado:", tempo, "tipo:", typeof tempo);
      //console.log("horarios atuais:", horarios);
    
      setForm(prev => ({
        ...prev,
        tempo,
        idHorario: ""
      }));
    
      if (tempo > 60) {
        const blocos = montarHorariosEmBlocos(horarios, tempo);
        console.log("blocos montados:", blocos);
        setBlocosHorarios(blocos);
      } else {
        console.log("entrou no <= 60");
        setBlocosHorarios([]);
      }
    }
  }

  function validarCampos() {
    const e = {};
    if (!form.idCadastro) e.idCadastro = "Informe o cliente";
    if (!form.data) e.data = "Informe a data";
    if (!form.idEspecialidade) e.idEspecialidade = "Informe a especialidade";
    if (!form.idHorario) e.idHorario = "Informe o horário";
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length > 0) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        const payload_create = criarAgendamentoPublicDTO({
          DATA: form.data,
          IDHORARIO: Number(form.idHorario),
          IDCADASTRO: Number(form.idCadastro),
          IDESPECIALIDADE: Number(form.idEspecialidade)
        });

        await AgendamentosService.create(payload_create);
        setRetorno({ tipo: "sucesso", mensagem: "Agendamento criado com sucesso!" });
      }

      if (modo === "alterar") {
        const payload_update = atualizarAgendamentoPublicDTO({
          DATA: form.data,
          IDHORARIO: Number(form.idHorario),
          IDCADASTRO: Number(form.idCadastro),
          IDESPECIALIDADE: Number(form.idEspecialidade),
        });

        await AgendamentosService.update(itemSelecionado.IDAGENDAMENTO, payload_update);
        setRetorno({ tipo: "sucesso", mensagem: "Agendamento atualizado com sucesso!" });
      }

      onClose();
    } catch {
      setRetorno({
        tipo: "erro",
        mensagem: modo === "novo"
          ? "Erro ao criar agendamento."
          : "Erro ao atualizar agendamento."
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={agendaIcon} alt="agendamentos" className="icon" />
          {modo === "novo" ? "Novo Agendamento" : "Alterar Agendamento"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cliente: *</div>
          <select name="idCadastro" value={form.idCadastro} onChange={handleChange}>
            <option value="">Selecione</option>
            {clientes.map(c => (
              <option key={c.IDCADASTRO} value={c.IDCADASTRO}>
                {c.NOME}
              </option>
            ))}
          </select>
          {errors.IDCADASTRO && <span className="erro">{errors.IDCADASTRO}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data: *</div>
          <input type="date" name="data" value={form.data} min={hoje} onChange={handleChange} />
          {errors.DATA && <span className="erro">{errors.DATA}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Especialidade: *</div>
          <select name="idEspecialidade" value={form.idEspecialidade} onChange={handleChange}>
            <option value="">Selecione</option>
            {especialidades.map(e => (
              <option key={e.IDESPECIALIDADE} value={e.IDESPECIALIDADE}>
                {e.DESCRICAO}
              </option>
            ))}
          </select>
          {errors.IDESPECIALIDADE && <span className="erro">{errors.IDESPECIALIDADE}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Horário: *</div>

          {form.tempo > 60 ? (
            <select name="idHorario" value={form.IDHORARIO} onChange={handleChange}>

              {modo === "novo" && (
                <option value="">Selecione</option>
              )}

              {modo === "alterar" && (
                <option value="">
                    {itemSelecionado ? `Horário agendado: ${itemSelecionado.HORARIO?.slice(0,5)}h` : "Selecione um horário"}
                </option>
              )}

              {blocosHorarios.map((bloco, index) => (
                <option key={index} value={bloco[0].idHorario}>
                  {bloco.map(h => h.horario.slice(0, 5)).join(" e ")}
                </option>
              ))}
            </select>
            ) : (
            <select name="idHorario" value={form.IDHORARIO} onChange={handleChange}>

              {modo === "novo" && (
                <option value="">Selecione</option>
              )}

              {modo === "alterar" && (
                <option value="">
                    {itemSelecionado ? `Horário agendado: ${itemSelecionado.HORARIO?.slice(0,5)}h` : "Selecione um horário"}
                </option>
              )}

              {horarios.map(h => (
                <option key={h.idHorario} value={h.idHorario}>
                  {h.horario.slice(0, 5)} h
                </option>
              ))}
            </select>
          )}

          {errors.idHorario && <span className="erro">{errors.idHorario}</span>}
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Salvando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
